const FeatureFlags = {
  install(Vue) {
    const flags = process.env.VUE_APP_FEATURE_FLAGS ? process.env.VUE_APP_FEATURE_FLAGS.split(',') : [];
    const featureFlags = {};
    flags.forEach((flag) => {
      featureFlags[flag] = true;
    });
    Object.defineProperty(Vue.prototype, '$featureFlags', { value: featureFlags });
  },
};

export default FeatureFlags;
